import type { CraftingEngine, CraftingRecipe, Inventory } from '@slimebound/core';

export class CraftingPanel {
  private engine: CraftingEngine;
  private inventory: Inventory;
  private onLog?: (msg: string) => void;
  private container: HTMLElement | null = null;
  private unlockedTraits: string[] = [];

  constructor(
    engine: CraftingEngine,
    inventory: Inventory,
    onLog?: (msg: string) => void,
    containerElement?: HTMLElement | null
  ) {
    this.engine = engine;
    this.inventory = inventory;
    this.onLog = onLog;

    if (containerElement !== undefined) {
      this.container = containerElement;
    } else if (typeof document !== 'undefined') {
      this.container = document.getElementById('hud-crafting-panel');
    }
  }

  public setUnlockedTraits(traits: readonly string[]): void {
    this.unlockedTraits = [...traits];
  }

  public getAvailableRecipes(): readonly CraftingRecipe[] {
    return this.engine
      .getAllRecipes()
      .filter((r) => this.engine.canCraft(r.id, this.inventory, this.unlockedTraits));
  }

  public craft(recipeId: string): boolean {
    const recipe = this.engine.getRecipe(recipeId);
    if (!recipe) return false;

    const success = this.engine.craft(recipeId, this.inventory, this.unlockedTraits);
    if (success && this.onLog) {
      this.onLog(`🔨 Crafted ${recipe.name}! (+${recipe.result.quantity})`);
    }
    return success;
  }

  public render(): void {
    if (!this.container) return;

    const available = this.getAvailableRecipes();
    if (available.length === 0) {
      this.container.innerHTML = `<div class="crafting-empty">No craftable recipes</div>`;
      return;
    }

    this.container.innerHTML = available
      .map(
        (r) => `<button class="craft-btn" data-recipe-id="${r.id}">Craft ${r.name}</button>`
      )
      .join('');
  }
}
